define('modules/form_editor/views/notice_view',['require','exports','module','base/view','ldsh!../templates/notice_view'],function(require, exports, module){
  "use strict";
  var BaseView = require("base/view");
  module.exports = BaseView.extend({
    template: require("ldsh!../templates/notice_view"),
    className: "ed-form-notice",
    events: {
      "click .js-close-notice": "close"
    },
    initialize: function(options){
      this.model = new Backbone.Model(options);
    },
    close: function(e){
      if(e){
        e.preventDefault();
      }
      this.remove();
    }
  });
});

